import { Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    borderColor: 'rgb(255,255,255,0.1)',
    borderTop: '1px solid rgb(255,255,255,0.1)',
    background: 'transparent',
    paddingTop: 8,
    paddingBottom: 8
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderColor: 'rgb(255,255,255,0.1)'
  },
}));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   // hide last border
//   '&:last-child td, &:last-child th': {
//     border: 0,
//   },
// }));

export interface CustomizedTablesProps {
  tableContent: any
  tableHeader?: { label: string, props?: any }[]
}
export default function CustomizedTables(props: CustomizedTablesProps) {

  const { tableContent, tableHeader } = props
  return (
    <TableContainer component={Paper} sx={{ margin: 0, paddingBottom: 0 }}>
      <Table sx={{ minWidth: { xs: 0, sm: '41rem' }, maxWidth: '100%' }}>
        {
          !!tableHeader?.length && (
            <TableHead>
              <TableRow>
                {
                  tableHeader.map((head) => {
                    return (
                      <StyledTableCell {...head?.props}>
                        <Typography variant='xs' color='text.secondary'>
                          {head.label}
                        </Typography>
                      </StyledTableCell>
                    )
                  })
                }
              </TableRow>
            </TableHead>
          )
        }
        {
          !!tableContent.length && (
            <TableBody sx={{ maxWidth: '90dvw' }}>
              {tableContent}
            </TableBody>
          )
        }
      </Table>
    </TableContainer >
  );
}
